/*global APP_VERSION */
import { DexfSettingsEnvironmentEnum } from '@inter-ikea-kompis/enums/';
import type {
  IShoppingCartServiceOptions,
  IShoppingListServiceOptions,
} from '@inter-ikea-kompis/services';
import store from '../state';
import { getDexfApiKey } from '../util/dexf';
import { selectKompisTranslations } from '../state/translations/translationsSelectors';
import {
  selectDexfSettings,
  selectExperienceGalleryBackUrl,
  selectCteGalleryBackUrl,
} from '../state/dexfSettings/dexfSettingsSelectors';
import { UrlUtility } from '../util/aactools/urlUtility';

const urlUtility = new UrlUtility();
const appInfo = urlUtility.getAppInfo();
// @ts-ignore
let uiPlatformParam = urlUtility.getCombinedQuery().uiPlatform;

(function setDocumentTitle() {
  document.title = urlUtility.getApplicationName().toUpperCase();
})();

// look at containing directory for dev builds
if (!uiPlatformParam && import.meta.env.MODE !== 'production') {
  const match = window.location.pathname.match(
    /(kiosk|irw|m2|nwp|mobile)(?=\/?)/
  );
  uiPlatformParam = match && match[0];
}

const consumer = 'ALGOT';
const applicationName = urlUtility.getApplicationName().toUpperCase();
const applicationVersion = APP_VERSION;
const uiPlatform = uiPlatformParam || 'kiosk';
const storeId = appInfo.storeId;
const contract = '36400';
const locale = `${appInfo.language.toLowerCase()}-${appInfo.country.toUpperCase()}`;
const country = appInfo.country;
const dexfVpcConfigurationVersion = '1.1';
const surveyWaitTimeSeconds = 180;
const surveyWaitTimeSecondsKiosk = 120;
const surveyWaitTimeSecondsOnSucceed = 4;
const isProd = import.meta.env.MODE === 'production';

export const applicationSettings = {
  applicationName,
  applicationVersion,
  uiPlatform,
  storeId,
  locale,
  country,
  consumer,
  contract,
  dexfVpcConfigurationVersion,
  surveyWaitTimeSeconds,
  surveyWaitTimeSecondsKiosk,
  surveyWaitTimeSecondsOnSucceed,
  isProd,
};

export const getIpexGalleryUrl = () => {
  const state = store.getState();

  return isProd
    ? selectExperienceGalleryBackUrl(state)
    : selectCteGalleryBackUrl(state);
};

export const getFrequentlyUsedServiceSettingsOptions = () => ({
  dexfApiKey: getDexfApiKey(applicationName),
  dexfEnvironment: DexfSettingsEnvironmentEnum.production,
  dexfApplicationId: applicationName,
  locale: locale,
  settings: selectDexfSettings(store.getState()),
});

export const translationSettings = {
  locale,
  translationPrefixApplication: applicationName,
  translationEndpoints: [
    '/addon-app/translations/kompis/en-XZ.json',
    '/addon-app/translations/kompis/{language}-{country}.json',
    '/addon-app/storagetwo/translations/en-XZ.json',
    '/addon-app/storagetwo/translations/{language}-{country}.json',
  ],
};

export const getShoppingListServiceOptions =
  (): IShoppingListServiceOptions => {
    const { consumer, contract, locale } = applicationSettings;
    const settings = selectDexfSettings(store.getState());
    const translations = selectKompisTranslations(store.getState());

    return {
      consumer,
      contract,
      locale,
      settings,
      translations,
    };
  };

export const getShoppingCartServiceOptions =
  (): IShoppingCartServiceOptions => {
    const { consumer, contract, applicationName, locale } = applicationSettings;
    const settings = selectDexfSettings(store.getState());

    return {
      consumer,
      contract,
      applicationName,
      locale,
      settings,
    };
  };
